import { AddItem } from '@wix/design-system';
import React from 'react';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CustomFieldsDisabledHint } from '../CustomFields';
import { DataExtensionState } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';

export interface AddCustomFieldCTAButtonProps {
  state: DataExtensionState;
  onClick?: () => void;
}

function _AddCustomFieldCTAButton({
  state,
  onClick,
}: AddCustomFieldCTAButtonProps) {
  const container = useWixPatternsContainer();
  const { translate: t } = container;

  return (
    <CustomFieldsDisabledHint
      disabled={state.disableAddCustomField}
      content={state.disableAddCustomFieldContent}
    >
      <AddItem dataHook="data-extension-add-new" onClick={onClick}>
        {t('cairo.customFields.addCustomField.CTA')}
      </AddItem>
    </CustomFieldsDisabledHint>
  );
}

export const AddCustomFieldCTAButton = observer(_AddCustomFieldCTAButton);
